<template>
  <div class="contentParty">
    <div class="custom-container">
      <div class="textAlign">
        <h4 class="title">
          {{ newdetail.newsTitle }}
        </h4>
        <p class="time" v-if="createTime.length>0">
          {{ createTime[0] }}
        </p>
      </div>
      <div class="lable">
        <span disabled class="firstLabel">{{newdetail.firstLabel}}</span>
        <span type="primary" plain class="secondLabel" @click="toSearch(item.labelId)" v-for="item in newdetail.secondLabels" :key="item.labelId">{{item.labelName}}</span>
        <span type="primary" plain class="otherLabel" v-if="otherLabel.length>0" @click="toSearch('',item)" v-for="(item,index) in otherLabel" :key="index">{{item}}</span>

      </div>
      <div class="content_txt" v-html="newsDetail" v-if="isShow" />
      <div class="content_txt" v-html="newsDetailMobile" v-if="MobileisShow" />
    </div>
  </div>
</template>
<script>
import { getNewsDetail, advertisementFlow } from "@/api/api";
export default {
  name: "News",
  data() {
    return {
      fullWidth: 0,
      isShow: true,
      MobileisShow: false,
      newdetail: {},
      newsDetailMobile: {},
      detail: "",
      createTime: [],
      newsDetail: "",
      otherLabel: ""
    };
  },
  created() {
    this.newURL();
    localStorage.setItem("newsId", this.$route.query.id);
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
    this.getNewsDetail();
    this.loading();
    this.style();
    window.addEventListener("resize", this.handleResize);
    this.webinercookies();
  },
  beforeDestroy: function() {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    isPC() {
      return this.$store.state.isPC;
    }
  },
  methods: {
    newURL() {
      const currentUrl = window.location.href;
      if (currentUrl.includes("www")) {
        let newURL = currentUrl.replace(new RegExp("www.", "gi"), "");
        window.location.href = newURL;
      }
    },
    webinercookies() {
      // 如果没有记录cookie
      if (!localStorage.getItem("webinersource")) {
        // 就不重新赋值
        let webinersource = this.$route.query.source;

        if (webinersource == undefined) {
          localStorage.setItem("webinersource", "www");
        } else {
          localStorage.setItem("webinersource", webinersource);
        }
        // console.log(1);
      } else {
        // 如果没有cookie就设置cookie
      }
    },
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          recordId: this.$route.query.id,
          path: "newsDetail",
          source: "",
          information: "news里面"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          recordId: this.$route.query.id,
          path: "newsDetail",
          source: this.$route.query.source,
          information: "news里面"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    },
    handleResize(event) {
      // this.fullWidth = document.documentElement.clientWidth;
      console.log(document.documentElement.clientWidth);
      // 页面宽度小于750px时，不显示地图
      if (document.documentElement.clientWidth < 576 && this.newsDetailMobile) {
        this.isShow = false;
        this.MobileisShow = true;
      } else {
        this.isShow = true;
        this.MobileisShow = false;
      }
    },
    style() {
      document.querySelector("span").fontsize = "20px";
    },
    toSearch(id, keywords) {
      this.$router.push({ path: "/media", query: { secondLabel: id, otherLabel: keywords } });
    },
    loading() {
      this.$loading({
        lock: true,
        background: "rgba(255, 255, 255,1)"
      });
      setTimeout(() => {
        this.$loading().close();
      }, 700);
    },
    getNewsDetail() {
      let id = this.$route.query.id;
      getNewsDetail({
        id: id,
        origin: 1 //前台
      }).then(res => {
        if (res.code != 10000) {
          this.$message.error(res.msg || "Failed to query news information");
          return;
        }
        this.newdetail = res.data || [];
        //  console.log(this.newdetail.othersLabel);
        // console.log(this.newdetail.othersLabel.split(','));
        if (this.newdetail.othersLabel) {
          this.otherLabel = this.newdetail.othersLabel.split(",");
          console.log(this.otherLabel);
        }

        this.newsDetail = this.newdetail.newsDetail;
        this.newsDetailMobile = this.newdetail.newsDetailMobile;
        this.createTime = this.newdetail.createTime.split(" ") || [];
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.textAlign {
  text-align: center;
}
.contentParty {
  background: url("https://retailplatform.oss-cn-hangzhou.aliyuncs.com/holdenWebH5/newsBg.png") no-repeat center top;
  background-size: 100vw 280px;
  min-height: 280px;
  padding-top: 81px;
  margin-bottom: 51px;
  // word-break: break-all;
  .custom-container {
    margin: 0 195px;
    background: #ffffff;
    padding: 66px 44px 44px;
    overflow: hidden;
    .title {
      color: #333;
      font-weight: 700;
      margin-top: 0;
    }
    .time {
      margin-top: 15px;
      margin-bottom: 29px;
    }
  }
}
.content_txt {
  /deep/ p {
    font-size: 18px;
    span {
      font-size: 18px;
    }
    strong {
      font-size: 24px;
    }
  }
  /deep/ video {
    // height: 500px!important;
  }
  span {
    font-size: 18px;
  }
  /deep/img {
    max-width: 100%;
  }
}
.lable {
  .firstLabel {
    color: #000;
    // margin-bottom: 50px;
    margin-right: 15px;
    font-size: 20px;
  }
  .secondLabel,
  .otherLabel {
    margin-right: 15px;
    // margin-bottom: 50px;
    font-size: 15px;
    display: inline-block;
    cursor: pointer;
    color: #2cb1e9;
    &:hover {
      color: #0087d7;
      text-decoration: underline;
    }
  }
}
@media screen and (max-width: 576px) {
  .contentParty {
    .custom-container {
      margin: 0 70px;
      .title {
        font-size: 70px;
      }
      .time {
        font-size: 50px;
      }
    }
  }
  .content_txt {
    font-size: 55px;
    /deep/p {
      font-size: 55px;
      span {
        font-size: 55px;
      }
      strong {
        font-size: 55px;
      }
    }
    a {
      font-size: 55px;
    }
  }
  a {
    .wscnph {
      width: 80%;
    }
  }
  .firstLabel {
    font-size: 55px !important;
    margin-right: 20px !important;
  }
  .secondLabel,
  .otherLabel {
    font-size: 35px !important;
    margin-right: 15px !important;
  }
}
</style>